// libs
import React from 'react';
import cx from 'classnames';
// styles
import styles from './InfoFooter.module.scss';
const InfoFooterWrapper = ({ className, children, renderInfo, showInfo, footerClassName, }) => {
    const footerInfo = typeof renderInfo === 'function' ? renderInfo() : renderInfo;
    return (React.createElement("div", { className: cx(className) },
        React.createElement("div", { className: styles.container }, children),
        showInfo && footerInfo && (React.createElement("div", { className: cx(styles.containerInfo, footerClassName) }, footerInfo))));
};
export default InfoFooterWrapper;
